module.exports = __webpack_public_path__ + "static/img/206.4a19452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/206.png
// module id = YOVc
// module chunks = 0